import {getConfig} from '../helper'
import _ from 'lodash'
import sht from '../config/automated/sht.js'
import crp from '../config/automated/crp.js'
import gwc from '../config/automated/generic-water-cooled.js'
import es3 from '../config/automated/es3.js'
import es from '../config/automated/es.js'

const configStore = {
  state: {
    config: {},
    configLoaded: false
  },
  actions: {
    async refreshConfig (context, payload) {
      let result = await getConfig(
        {
          'facility_name': payload.facility_name
        }
        )
      context.commit('updateConfig', result)
    }
  },
  getters: {
    chillerType (state) {
      // generic, air-cooled 2 circuits
      return _.get(state.config,'chiller type', 'generic water-cooled')
    },
    faultEquipType (state) {
      return _.get(state.config,'faultEquipType', null)
    },
    controlLogicEquipType (state) {
      return _.get(state.config,'controlLogicEquipType', null)
    },
    anomalyEquipType (state) {
      return _.get(state.config,'anomalyEquipType', null)
    },
    automatedViewsConfig(state,getters, rootState){
      if(process.env.VUE_APP_AUTOMATED_CONFIG){
        let forcedConf=require('../config/automated/'+process.env.VUE_APP_AUTOMATED_CONFIG+".js")
        return forcedConf.default
      } else {
        let defaultValue={};
        if (rootState.pointsListStore.pointsList.facility_name==="SHT"){
          defaultValue=sht;
        } else if (rootState.pointsListStore.pointsList.facility_name==="CRP"){
          defaultValue=crp;
        } else if (rootState.pointsListStore.pointsList.facility_name==="ES3"){
          defaultValue=es3;
        } else if (rootState.pointsListStore.pointsList.facility_name==="ES"){
          defaultValue=es;
        } else if(_.get(state.config,'chiller type', 'generic water-cooled')==='generic water-cooled'){
          defaultValue=gwc;
        }
        return _.get(state.config,'automatedViewsConfig', defaultValue)
      }

    },
    returnTempVar (state) {
      return _.get(state.config,'return temp variable', 'SWR_Temp')
    },
    chillerPowerVar (state) {
      return _.get(state.config,'Chiller Power Variable', 'Comp_Power')
    },
    chillerCOPVar (state) {
      return _.get(state.config,'Chiller COP Variable', 'efficiency')
    }
  },
  mutations: {
    updateConfig (state, payload) {
      let output = {}
      for (let i in payload.result) {
        output[payload.result[i].config_name] = payload.result[i].config
      }
      state.config = output
      state.facility_name = payload.facility_name
      state.configLoaded = true
    }
  }
}

export default configStore
